var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3513 -487.417)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M10,12H2a2,2,0,0,1-2-2V9.6H.8a.4.4,0,1,0,0-.8H0V7.6H.8a.4.4,0,1,0,0-.8H0V5.6H.8a.4.4,0,1,0,0-.8H0V3.6H.8a.4.4,0,1,0,0-.8H0V2A2,2,0,0,1,2,0h8a2,2,0,0,1,2,2v8A2,2,0,0,1,10,12Z",
    transform: "translate(3513 487.417)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3516.309 489.903)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112.569,0a1.778,1.778,0,1,0,1.778,1.778A1.783,1.783,0,0,0,112.569,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.867)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.356,249.134a1.651,1.651,0,0,0-.181-.326,2.24,2.24,0,0,0-1.548-.963.334.334,0,0,0-.228.054,1.938,1.938,0,0,1-2.263,0,.3.3,0,0,0-.228-.054,2.224,2.224,0,0,0-1.548.963,1.9,1.9,0,0,0-.181.326.163.163,0,0,0,.008.148,3.091,3.091,0,0,0,.212.311,2.964,2.964,0,0,0,.362.4,4.7,4.7,0,0,0,.362.311,3.619,3.619,0,0,0,4.275,0,3.443,3.443,0,0,0,.362-.311,3.6,3.6,0,0,0,.362-.4,2.718,2.718,0,0,0,.212-.311A.131.131,0,0,0,30.356,249.134Z",
    transform: "translate(-24.165 -247.841)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.b1af7a6f92b3fa4b49507a84cad9a260.svg";
export { ForwardRef as ReactComponent };